module.exports = __webpack_public_path__ + "static/img/last_overall_balance.84d38fa3.png";